import type { QuizPlayQuestion } from './types'

export type QuizUiVariant = 'choice' | 'text' | 'this_or_that' | 'mosaic' | 'sorted'

const isSortedWords = (question: QuizPlayQuestion) =>
  question.kind === 'sorted' || question.family === 'sorted_words'

const isFreeText = (question: QuizPlayQuestion) => {
  if (question.family === 'text_free' || question.family === 'qr_static') return true
  const questionKind = question.meta?.question_kind
  return questionKind === 'text' || questionKind === 'qr_code'
}

export const resolveQuizUiVariant = (question: QuizPlayQuestion): QuizUiVariant => {
  if (isSortedWords(question)) return 'sorted'
  if (question.kind === 'this_or_that') return 'this_or_that'
  if (question.kind === 'mosaic') return 'mosaic'
  if (isFreeText(question)) return 'text'

  return 'choice'
}
